import { call, put, all, takeLatest } from "redux-saga/effects";
import {
  getShopMenu,
  getShopStaff,
  getShopDiscount,
  getShopDetail,
  getShopTable,
} from "./api";
import {
  setShopMenu,
  setShopStaff,
  setShopDiscount,
  setShopDetail,
  setShopTable,
} from "./actions";
import {
  GET_SHOP_MENU,
  GET_SHOP_STAFF,
  GET_SHOP_DISCOUNT,
  GET_SHOP_DETAIL,
  GET_SHOP_TABLE,
} from "./types";

function* handleGetShopMenu(action) {
  try {
    const result = yield call(getShopMenu, action.payload);
    const menus = result.data.results;
    yield put(setShopMenu(menus));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* handleGetShopSaff(action) {
  try {
    const result = yield call(getShopStaff, action.payload);
    const menus = result.data.results;
    yield put(setShopStaff(menus));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* handleGetShopDiscount(action) {
  try {
    const result = yield call(getShopDiscount, action.payload);
    const discounts = result.data.results;
    yield put(setShopDiscount(discounts));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* handleGetShopDetail(action) {
  try {
    const result = yield call(getShopDetail, action.payload);
    const shopDetail = result.data;
    yield put(setShopDetail(shopDetail));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* handleGetShopTable(action) {
  try {
    const result = yield call(getShopTable, action.payload);
    const tables = result.data.results;
    yield put(setShopTable(tables));
  } catch (e) {
    // yield put(actions.loginError());
    throw e;
  }
}

function* appSaga() {
  yield all([
    takeLatest(GET_SHOP_MENU, handleGetShopMenu),
    takeLatest(GET_SHOP_STAFF, handleGetShopSaff),
    takeLatest(GET_SHOP_DISCOUNT, handleGetShopDiscount),
    takeLatest(GET_SHOP_TABLE, handleGetShopTable),
    takeLatest(GET_SHOP_DETAIL, handleGetShopDetail),
  ]);
}

export default appSaga;
